var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"播放语音","placement":"bottom"}},[_c('img',{staticClass:"func-img",attrs:{"src":"https://bookor-application.oss-cn-beijing.aliyuncs.com/mp3.png"},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }